import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URLs } from '../constants/URLS';
import { ResponsePreguntas } from '../domains/response-preguntas';
import { RequestValidacionRespuestas } from '../domains/request-validacion-respuestas';
import { ResponseValidacionRespuestas } from '../domains/response-validacion-respuestas';

@Injectable({
  providedIn: 'root'
})
export class ValidacionClienteService {
  private preguntas: ResponsePreguntas;
  private token: string;

  get cifrado() {
    return this.token;
  }
  set cifrado(cifrado: string) {
    this.token = cifrado;
  }

  constructor(private readonly httpClient: HttpClient) {}
  obtenerPreguntas(request) {
    return this.httpClient.post<ResponsePreguntas>(
      `${URLs.base}${URLs.obtenerPreguntas}`,
      request
    );
  }

  validarEsCliente(rut: string, captcha: string) {
    return this.httpClient.post<boolean>(
      `${URLs.base}${URLs.validarCliente}?g-recaptcha-response=${captcha}`,
      { rut: rut }
    );
  }

  validarRespuestas(request: RequestValidacionRespuestas) {
    return this.httpClient.post<ResponseValidacionRespuestas>(
      `${URLs.base}${URLs.validarRespuestas}`,
      request
    );
  }

  setPreguntas(preguntas: ResponsePreguntas) {
    this.preguntas = preguntas;
  }

  getPreguntas(): ResponsePreguntas {
    return this.preguntas;
  }
}
